import DigitalAssetModelBase from '../_generated/modelBases/digital-asset-model-base';

export default class DigitalAssetModel extends DigitalAssetModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
